<!--
 * @Author: xuquantong
 * @Date: 2022-05-26 20:15:08
 * @LastEditors: fangzhi fangzhi@vivo.com
 * @LastEditTime: 2023-11-10 09:35:07
 * @Description: 定金预售流程
-->
<template>
  <div v-if="discountType === 'deposit'">
    <div class="product-info-earnest">
      <div class="bg-line"></div>
      <div class="steps">
        <div class="step-item" tabindex="0">
          <div class="label">
            <span class="name">1.付定金</span>
            <div class="step-line border1px"></div>
          </div>
          <div class="info">
            <span class="rmb">&yen;</span>
            <span class="price fs-36">{{ commodityDeposit.depositAmount | formatMoney }}</span>
            <span class="ext-info" v-if="commodityDeposit.depositSwellAmount">
              (抵￥{{ commodityDeposit.depositSwellAmount | formatMoney }})
            </span>
          </div>
          <div class="time" :aria-label="`截止时间为${formatTimeAriaLabel(commodityDeposit.depositEndTime)}`">
            <span class="vector"></span>
            {{ depositEndTime }}截止
          </div>
        </div>
        <div class="step-item" tabindex="0">
          <div class="label">
            <span class="name">2.付尾款</span>
            <div class="step-line border1px"></div>
          </div>
          <div class="info">
            <span class="rmb">&yen;</span>
            <span class="price fs-36" v-if="tailAmount">{{ tailAmount | formatMoney }}</span>
          </div>
          <div class="time" :aria-label="`开始时间为${formatTimeAriaLabel(commodityDeposit.tailBeginTime)}`">
            {{ tailBeginTime }}开始
          </div>
        </div>
        <div class="step-item send">
          <div class="label">
            <span class="name">3.发货</span>
            <i class="warn" @click="show"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const formatTime = time => {
  const z = num => (num >= 10 ? num : `0${num}`)

  const date = new Date(Number(time))
  const mouth = z(date.getMonth() + 1)
  const day = z(date.getDate())
  const h = z(date.getHours())
  const m = z(date.getMinutes())
  const s = z(date.getSeconds())
  return `${mouth}.${day} ${h}:${m}:${s}`
}
export default {
  name: 'EarnestMoney',
  props: {
    skuInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters('detailv3', ['discountType', 'currentSuiteInfo']),
    discountDetail() {
      return this.skuInfo.commoditySkuDiscount.commoditySkuDiscountDetail || {}
    },
    commodityDeposit() {
      return this.discountDetail.commodityDeposite || {}
    },
    tailBeginTime() {
      return formatTime(this.commodityDeposit.tailBeginTime)
    },
    depositEndTime() {
      return formatTime(this.commodityDeposit.depositEndTime)
    },
    depositRule() {
      return this.commodityDeposit.depositRule
    },
    tailAmount() {
      const tailAmountExcludeSwellAmount = this.discountDetail?.commodityDeposite?.tailAmountExcludeSwellAmount || 0
      const depositSwellAmount = this.discountDetail?.commodityDeposite?.depositSwellAmount || 0
      const depositAmount = this.discountDetail?.commodityDeposite?.depositAmount || 0
      const totalPrice = this.currentSuiteInfo?.totalPrice
      if (this.currentSuiteInfo?.totalPrice) {
        if (depositSwellAmount) {
          return totalPrice - depositSwellAmount
        } else {
          return totalPrice - depositAmount
        }
      } else {
        return tailAmountExcludeSwellAmount
      }
    }
  },
  methods: {
    show() {
      this.$osDialog.alert({
        title: '预售规则',
        content: `<div>${this.depositRule}</div>`,
        confirmStyles: {
          color: '#e90f23'
        }
      })
    },
    formatTimeAriaLabel(time) {
      const z = num => (num >= 10 ? num : `0${num}`)

      const date = new Date(Number(time))
      const mouth = z(date.getMonth() + 1)
      const day = z(date.getDate())
      const h = z(date.getHours())
      const m = z(date.getMinutes())
      const s = z(date.getSeconds())
      return `${mouth}月${day}日 ${h}:${m}:${s}`
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-1 {
  .steps .step-item .info {
    margin-top: 38px;
  }
}
.vivo-fontscale-2 {
  .steps .step-item .info {
    margin-top: 32px;
  }
}
.vivo-fontscale-4 {
  .steps .step-item .info {
    margin-top: 18px;
  }
}
.vivo-fontscale-5 {
  .steps .step-item .info {
    margin-top: 10px;
  }
  .product-info-earnest {
    padding: 30px 7px 34px 7px;
    .bg-line {
      left: 10px;
    }
  }
}
</style>
<style lang="scss">
::v-deep .earnest-dialog {
  .v-dialog__header {
    @include dialog-bgcolor;
  }
}
</style>
